export async function validateSession(sessionId: string) {
  if (!sessionId || sessionId === '') return;
  return await fetch(`${process.env.REACT_APP_API_PATH}/sessions`, {
    headers: {
      'x-session-id': sessionId,
    },
  })
    .then(async (response) => {
      if (response.status === 200) {
        const json = await response.json();
        return json;
      }
      return false;
    })
    .catch((error) => {
      console.error('Error:', error);
      return { errorMessage: 'Failed to validate session' };
    });
}

export async function initializeSession(nonce: string) {
  if (!nonce || nonce === '') return;

  return await fetch(`${process.env.REACT_APP_API_PATH}/sessions/initialize`, {
    headers: {
      'x-nonce': nonce,
    },
  })
    .then(async (response) => {
      if (response.status === 200) {
        const json = await response.json();
        const {
          session_id: sessionId,
          c,
          languages,
          platform_version: platformVersion,
          is_client_publickey_present: isClientPublicKeyPresent,
          enable_agent_trainer: enableAgentTrainer = false,
          genAi_key_option: genAiKeyOption,
          consumer_id: consumerId,
          manager_id: managerId,
          error_webhooks: errorWebhooks,
        } = json;
        return {
          sessionId,
          c,
          languages,
          platformVersion,
          isClientPublicKeyPresent,
          enableAgentTrainer,
          genAiKeyOption,
          errorMessage: null,
          consumerId,
          managerId,
          errorWebhooks,
        };
      }
      return;
    })
    .catch((error) => {
      console.error('Error:', error);
      return {
        errorMessage: 'Request failed to initialize a session',
        sessionId: null,
        c: null,
        languages: null,
        platformVersion: null,
        isClientPublicKeyPresent: null,
        enableAgentTrainer: false,
        genAiKeyOption: '',
        consumerId: '',
        errorWebhooks: [],
      };
    });
}

export async function deleteSession(sessionId: string) {
  if (!sessionId || sessionId === '') return;

  return await fetch(`${process.env.REACT_APP_API_PATH}/sessions`, {
    method: 'DELETE',
    headers: {
      'x-session-id': sessionId,
    },
  })
    .then(async (response) => {
      if (response.status === 200) {
        return true;
      }
      return false;
    })
    .catch((error) => {
      console.error('Error:', error);
      return false;
    });
}

export default validateSession;
